import clsx from 'clsx/lite';
import { ReactNode, type FC } from 'react';
import styles from './Table.module.css';
import TableHeaderRow from './TableHeaderRow';
import TableRow from './TableRow';
import type { HeaderItem, TableRowItem } from './types';

interface TableProps {
  className?: string;
  wrapperClassName?: string;
  theadClassName?: string;
  tbodyClassName?: string;
  tfootClassName?: string;
  headers: HeaderItem[];
  rows?: TableRowItem[];
  footer?: ReactNode;
}

const Table: FC<TableProps> = ({
  className,
  wrapperClassName,
  headers,
  rows,
  theadClassName,
  tbodyClassName,
  tfootClassName,
  footer,
}) => {
  if (!headers && !rows) {
    return null;
  }

  return (
    <div className={clsx(styles.wrapper, wrapperClassName)}>
      <table className={clsx(styles.tableContainer, className)}>
        <thead className={clsx(styles.tableHeaderRow, theadClassName)}>
          <TableHeaderRow headers={headers} />
        </thead>
        <tbody className={tbodyClassName}>
          {rows?.map((row) => <TableRow key={row.key} row={row} ref={row.ref} />)}
        </tbody>
        {footer && <tfoot className={tfootClassName}>{footer}</tfoot>}
      </table>
    </div>
  );
};

export default Table;
